import React from 'react';

import { usePixels } from '../../store/hooks/offers';

import styles from './pixels.module.scss';

export const Pixels = () => {
  const pixels = usePixels();
  if (!pixels?.length) return null;

  return (
    <div className={styles.pixels}>
      {pixels?.map((url, i) => (
        <img
          src={url}
          alt=""
          style={{
            width: '1px',
            height: '1px',
            outline: 'none',
            display: 'none',
          }}
          // eslint-disable-next-line react/no-array-index-key
          key={`pixel-${url}-${i}`}
        />
      ))}
    </div>
  );
};
